import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requirePermission } from '../../../../app/guards'

export const Route = createFileRoute('/_app/commissions/runs')({
  staticData: { crumb: 'commissionRuns' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'commissions.read'),
  component: Outlet,
})
